import { useRef, useState } from "react";

const AccordionItem = (prop) => {
    const contentEl = useRef();
    const { hadleToggle, active, termText, chkBtn } = prop;
    const { header, id, contents, chkID } = termText;
    const [checked, setChecked] = useState(true);
    const checkHandled = ({target}) =>{
        chkBtn(target.checked);
        setChecked(!checked);
    }
    return(
        <div className="accordionBox">
            <div className={`accordionHeader active`} /* onClick={() => hadleToggle(id)}*/>
                <div className="checkbox title">
                    <input type="checkbox" id={chkID} name="category_id" checked={checked} onChange={(e) => checkHandled(e)}/><label htmlFor={chkID} className="check_list mediumTit txtBold">{header}</label>
                </div>
                <span className="iconArrow noIcon"></span>
            </div>
            <div ref={contentEl} className={`accordionBoby show`} style={
                active === id
                ? { height: contentEl.current.scrollHeight }
                : {}
            }>
                <div className="listWrap">{contents}</div>
            </div>
        </div>
    )
}
export default AccordionItem;